import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import CustomDatePicker from "../../CustomDatePicker";
import moment from "moment/moment";
import { useFormFilterAirCallAndRingCentral } from "./hooks/useFormFilterAirCallAndRingCentral";

const FormFilterAirCallAndRingCentral = (props) => {
  const { initialData, setFilters, theme } = props;

  const {
    filterCopy,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    updateFilters,
    handleChangeFilters,
    resetFilters,
  } = useFormFilterAirCallAndRingCentral(setFilters, initialData);

  return (
    <Form
      style={{ width: 280 }}
      onSubmit={(e) => {
        e.preventDefault();
        updateFilters();
      }}
    >
      <Row className="m-0">
        <Col sm={12} md={12} lg={12} xl={12} className="p-0">
          <Form.Group className="m-2">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              name="phoneNumber"
              placeholder="write a phone number"
              value={filterCopy.phoneNumber}
              onChange={handleChangeFilters}
            />
          </Form.Group>
          <Form.Group className="m-2">
            <Form.Label>Date From</Form.Label>
            <CustomDatePicker
              value={dateFrom ? moment(dateFrom).toDate() : dateFrom}
              name="dateTo"
              onChange={(date) => setDateFrom(date)}
            />
          </Form.Group>
          <Form.Group className="m-2">
            <Form.Label>Date To</Form.Label>
            <CustomDatePicker
              value={dateTo}
              name="dateTo"
              onChange={(date) => setDateTo(date)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Form.Group className="m-2 text-center">
        <Button
          className={`${theme.hoverPrimaryClassButton} mt-3`}
          style={{ backgroundColor: theme.primary }}
          type="submit"
        >
          Apply filters
        </Button>

        <Button
          className={`${theme.hoverSecondaryClassButton} mt-3 ml-1`}
          style={{ backgroundColor: theme.secondary, color: theme.black }}
          type="button"
          onClick={() => {
            resetFilters();
            //updateFilters();
          }}
        >
          Reset
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormFilterAirCallAndRingCentral;
